'use strict';

var Wysiwyg = require('./lib/wysiwyg');

// Constructor
var ResponsiveEmbed = function() {
  var self = this;

  self.config = {
    wysiwyg: '.wysiwyg',
    responsiveEmbedEl: '<div class="responsive-embed"></div>'
  }

  self.init = function() {
    new Wysiwyg(self.config).init();
  }
};

module.exports = ResponsiveEmbed;
